import '../css/App.css'
import "css/mod_styles.css"
import {Layout} from "antd"
import SiteHeader from "components/Header"
import {BrowserRouter, Navigate, Outlet, Route, Routes} from "react-router-dom"
import LoginPage from "components/LoginPage"
import AdminPage from "components/admin/AdminPage"
import DoctorPage from "components/doctor/DoctorPage"
import PatientPage from "components/patient/PatientPage"
import GraphContainer from "components/graph/GraphContainer"
import store from "redux/store"
import {Provider} from "react-redux"
import SharedPage from "components/shared/SharedPage"

const {Content} = Layout

export default function App() {

	if (process.env.REACT_APP_MODE === "STANDALONE") {
		return (
			<Provider store={store}>
				<GraphContainer/>
			</Provider>
		)
	}

	return (
		<Provider store={store}>
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<Site/>}>
						<Route path="login" element={<LoginPage/>}/>
						<Route path="admin/*" element={<AdminPage/>}/>
						<Route path="doctor/*" element={<DoctorPage/>}/>
						<Route path="patient/*" element={<PatientPage/>}/>
						<Route path="" element={<Navigate to="login"/>}/>
					</Route>
					<Route path="/graph" element={<GraphContainer/>}/>
					<Route path="/sharedDecision/*" element={<SharedPage/>}/>
				</Routes>
			</BrowserRouter>
		</Provider>
	)
}

function Site() {
	return (
		<Layout className="site_container">
			<SiteHeader/>
			<Content>
				<Outlet/>
			</Content>
		</Layout>
	)
}
